import React, { useState } from "react";
import { Row, Col, Card, Form, Input, Spin, PageHeader, Alert, Select } from "antd";
import { useSelector } from "react-redux";
import { CustomBtn } from "../../components/Button";
import { useBillFeesMutation, useBillStartimeGetMutation, useBillStartimePayMutation } from "./service/bill-api";
import TransactionResume from "../../components/Dialog/transaction-resume";
import SuccessDialog from "../../components/Dialog/success";
import { loadFeaturesState } from "../../redux/featuresStorage";
const { Option } = Select;


export function BillCollectePage() {
    const { currentAgent } = useSelector((state) => state.auth);
    const [billStartimeGet] = useBillStartimeGetMutation();
    const [billStartimePay] = useBillStartimePayMutation();
    const [billFees] = useBillFeesMutation();
    const [show, setShow] = useState(false);
    const [forfaits, setForfaits] = useState([]);
    const [forfait, setForfait] = useState([]);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const [isCustomer, setIsCustomer] = useState(false);
    const [fees, setFees] = useState();
    const [formdata, setFormData] = useState([]);
    const [form] = Form.useForm();

    const feature = loadFeaturesState();


    console.log("feature", feature);

    const handleSearch = async (value) => {
        setIsLoading(true);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "pincode": "",
            "reference": value.service_code,
            "service": "STARTIME",
            "operation": "GET",
            "country": currentAgent.country,
            "token": currentAgent.access_token
        }
        setFormData(value)
        billStartimeGet(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setForfaits(res.invoices)
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    const handleFees = async (value) => {
        setIsLoading(true);
        const data = {
            "agent_msisdn": currentAgent.phone,
            "agent_pin": "",
            "operation": "COLLECTE",
            "receiver": "76219",
            "country": currentAgent.country,
            "bills": [JSON.parse(value.forfait)]
        };
        setForfait(JSON.parse(value.forfait))
        billFees(data)
            .unwrap()
            .then((res) => {
                setIsLoading(false);
                setError();
                setFees(res);
                setShow(true);
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    const handlePay = async (pin) => {
        setIsLoading(true);
        setShow(false);
        const data = {
            "reference": formdata.service_code,
            "service": "STARTIME",
            "operation": "RELOAD",
            "agent_msisdn": currentAgent.phone,
            "agent_pin": pin,
            "country": currentAgent.country,
            "additional_info": formdata.phone_number,
            "token": currentAgent.access_token,
            "bills": [forfait]
        };
        billStartimePay(data)
            .unwrap()
            .then(() => {
                setIsSuccess(true);
                setIsLoading(false);
                setIsCustomer(false);
                setForfaits([])
                form.resetFields();
            })
            .catch((error) => {
                setIsLoading(false);
                setError(error.data.error);
            });
    };

    return (
        <div className="default-page">
            <TransactionResume
                title={`PAIEMENT ${feature?.title} F CFA`}
                message={
                    "Vous allez effectuer un payement STARTIME d'un montant de " +
                    fees?.amount +
                    " F CFA"
                }
                fees={fees?.fees}
                status={show}
                handleCancel={() => setShow(false)}
                handlePay={handlePay}
            />
            <SuccessDialog
                message="Payement effectué avec succès"
                status={isSuccess}
                handleCancel={() => setIsSuccess(false)}
            />
            <PageHeader title={`Payement ${feature?.title}`} />
            <Spin tip="Chargement..." spinning={isLoading}>
                <Row gutter={16}>
                    <Col lg={12} xs={24}>
                        <Card>
                            <Form name="basic" form={form} layout="vertical" onFinish={forfaits.length ? handleFees : handleSearch}>
                                <Form.Item
                                    label="Numéro de carte client"
                                    name="service_code"
                                    rules={[{ required: true, message: "Veuillez saisir un numéro" }]}>
                                    <Input
                                        className="form-control"
                                        name="service_code"
                                        placeholder="Numéro de carte client"
                                        onChange
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Numero du client"
                                    name="phone_number"
                                    rules={[{ required: true, message: "entrer le numero client" }]}>
                                    <Input
                                        className="form-control"
                                        placeholder="Numero du client"
                                    />
                                </Form.Item>
                                {forfaits.length > 0 && (
                                    <Form.Item label="Forfait:" name="forfait">
                                        <Select placeholder="Forfait" style={{ width: "100%" }}>
                                            {forfaits.map(element => <Option value={JSON.stringify(element)}> {element.reference} - {element.amount}</Option>)}
                                        </Select>
                                    </Form.Item>
                                )}
                                {error && (
                                    <Form.Item>
                                        <Alert message={error} type="error" showIcon />
                                    </Form.Item>
                                )}
                                <Form.Item>
                                    <CustomBtn title={forfaits.length > 0 ? "Valider" : "Rechercher"} />
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Spin>
        </div>
    );
}
export default BillCollectePage;
